import { ValidationError } from "sequelize"
import {
    CcApprovalLevel,
    CcApprovalLevelCreate,
    CcApprovalLevelSave,
} from "server/models"
import { ASC } from "const"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import {
    CcApprovalLevelList,
    CcApprovalLevelValidation,
} from "./types"

export const LoadCcApprovalLevels = (
    accountId: number,
    projectId: number,
    module: number,
) => (
    GET(`/ccApprovalLevel/accountId/${accountId}/projectId/${projectId}/module/${module}`)
    .then((levels: CcApprovalLevel[]) => {
        const levelList: CcApprovalLevelList = {}
        levels.forEach((level) => {
            levelList[level.id] = level
        })

        const levelsSorted = levels.sort((a, b) => sort(a, b, "order", ASC))
        const levelIds: number[] = []
        levelsSorted.forEach((level) => {
            levelIds.push(level.id)
        })

        return { levelList, levelIds }
    })
)

export const LoadCcApprovalLevelById = (
    levelId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccApprovalLevel/id/${levelId}/accountId/${accountId}/projectId/${projectId}`)
    .then((level: CcApprovalLevel) => level)
)

export const SaveCcApprovalLevel = (
    id: number,
    level: CcApprovalLevelCreate,
    lang: LangType,
) => {
    const data: CcApprovalLevelSave = {
        id,
        level,
    }
    return POST(
        "/ccApprovalLevel/save",
        JSON.stringify(data),
    ).then((res) => {
        const newLevel = res as CcApprovalLevel
        const error = res as ValidationError
        return {
            newLevelId: newLevel.id || null,
            newLevelOrder: newLevel.order || null,
            validation: <CcApprovalLevelValidation>validate(error, lang),
        }
    })
}

export const DragnDropCcApprovalLevel = (
    levelIds: readonly number[],
    levelList: CcApprovalLevelList,
) => {
    const data: CcApprovalLevel[] = []
    levelIds.forEach((id, index) => {
        data.push({
            ...levelList[id],
            order: index,
        })
    })

    return POST(
        "/ccApprovalLevel/updateMany",
        JSON.stringify(data),
    ).then((success: boolean) => success)
}

export const DeleteCcApprovalLevel = (levelId: number) => (
    DELETE(`/ccApprovalLevel/delete/${levelId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcApprovalLevels = (
    accountId: number,
    projectId: number,
    defaultGroupsAssigned: boolean,
) => (
    GET(`/ccApprovalLevel/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultGroupsAssigned}`)
    .then((success: boolean) => success)
)
